import React, { Fragment } from 'react'
import styles from './AdminActionDialogs.scss'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import fetchJSON from 'lib/fetchJSON'
import { CircleSpinner } from 'common/spinners/CircleSpinner'
import { CTA } from 'common/styleguide/CTA'
import smartDate from '@qrohlf/smart-date'
import moment from 'moment'

export const USER_INFO_DIALOG = 'USER_INFO_DIALOG'
export const USER_LOGIN_HISTORY_DIALOG = 'USER_LOGIN_HISTORY_DIALOG'
export const MOONIFY_USER_DIALOG = 'MOONIFY_USER_DIALOG'
export const FLAG_USER_AS_IMPORTANT_DIALOG = 'FLAG_USER_AS_IMPORTANT_DIALOG'
export const UNAUTHENTICATE_USER_DIALOG = 'UNAUTHENTICATE_USER_DIALOG'
export const USER_DEACTIVATION_DIALOG = 'USER_DEACTIVATION_DIALOG'
export const TROUTE_DELETE_PHOTOS_MODAL = 'TROUTE_DELETE_PHOTOS_MODAL'

export class FlagUserAsImportant extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = { success: false }
  }

  onSubmit = () => {
    const { onRequestClose, userId } = this.props
    const body = {
      flagged_user: {
        associated_object_id: userId,
        associated_object_type: 'User',
        user_id: userId,
        notes: this._input.value
      }
    }

    fetchJSON('/flagged_users', body, { method: 'POST' })
      .then(r => {
        this.setState({ success: true })
        setTimeout(() => onRequestClose(), 1000)
      })
  }

  render () {
    const { success } = this.state
    const { onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title='Flag as important'
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={success ? onRequestClose : this.onSubmit}
        confirmText={success ? 'Close' : 'Go'}>
        {success
          ? <div>great!</div>
          : <form onSubmit={this.onSubmit}>
            <label htmlFor='notes'>Notes</label>
            <input
              ref={r => { this._input = r }}
              id='notes'
              type='text' />
          </form>}
      </ConfirmationDialog>
    )
  }
}

export class UserLoginHistory extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      done: false,
      history: [],
      page: 0
    }
  }

  componentDidMount () {
    this.getLoginData()
  }

  getLoginData = () => {
    this.setState({ loading: true })
    fetchJSON(`/users/${this.props.userId}/login_history?page=${this.state.page}`)
      .then(r => {
        if (r.length === 0) this.setState({ done: true, loading: false })
        else this.setState({ history: this.state.history.concat(r), loading: false })
      })
  }

  onLoadClick = () => {
    this.getLoginData()
    this.setState({ page: this.state.page + 1 })
  }

  render () {
    const { loading, history, done } = this.state
    const { onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title='User Login History'
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={onRequestClose}
        confirmText='Dismiss'>
        <>
          <LoginHistory history={history} />
          {loading && !history && <CircleSpinner centered size={30} />}
          {!done
            ? <div className={styles.loadMoreContainer}>
              <CTA secondary margins={false} style={{ 'width': 'auto' }} onClick={this.onLoadClick}>
                {loading ? <CircleSpinner centered size={14} /> : `Load more`}
              </CTA>
            </div>
            : <video autoPlay loop poster='' muted className={styles.video}>
              <source src='https://media.giphy.com/media/5bo7UYW69cYQZA4tOF/giphy.mp4' type='video/mp4' />
            </video>
          }
        </>
      </ConfirmationDialog>
    )
  }
}

const LoginHistoryRow = ({ label, value }) => <tr className={styles.row}>
  <td>{label}</td>
  <td>{value}</td>
</tr>

const LoginHistory = ({ history }) => {
  return <table className={styles.table}>
    <tbody>
      {history && history.map(({ label, value }) => <LoginHistoryRow label={label} value={value} />)}
    </tbody>
  </table>
}

export class MoonifyUser extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      confirmed: false
    }
  }

  moonify = () => {
    fetchJSON(`/users/${this.props.userId}/moonify`, false, { method: 'POST' })
      .then(r => {
        this.setState({ confirmed: true })
        setTimeout(() => this.props.onRequestClose(), 3500)
      })
  }

  render () {
    const { confirmed } = this.state
    const { onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title={confirmed ? 'He\'ll ya' : 'Are you sure?'}
        maxWidth='600px'
        onConfirm={() => confirmed ? onRequestClose() : this.moonify()}
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        confirmText={confirmed ? '😎' : 'OK'}>
        <div className={styles.moonify}>
          {confirmed
            ? <img src={'/images/itworked.gif'} />
            : <img src={'/images/moonify.gif'} />}
        </div>
      </ConfirmationDialog>
    )
  }
}

export class UserInfo extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      userInfo: null
    }
  }

  componentDidMount () {
    const { user } = this.props
    fetchJSON(`/users/${user.id}/user_info`)
      .then(r => this.setState({ userInfo: r, loading: false }))
      .catch(r => this.setState({ loading: false }))
  }

  render () {
    const { loading, userInfo } = this.state
    const { onRequestClose, user } = this.props

    return (
      <ConfirmationDialog
        primary
        title='User Info'
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={onRequestClose}
        confirmText='Dismiss'>
        {loading || !userInfo
          ? <CircleSpinner centered size={30} />
          : <Info info={userInfo} user={user} />}
      </ConfirmationDialog>
    )
  }
}

const Row = ({ label, value }) => <dl className={styles.infoRow}>
  <dt>{label}</dt>
  <dd>{value}</dd>
</dl>

const Info = ({ info, user }) => {
  return <div className={styles.info}>
    <Row label='Name' value={info.nameFormal} />
    <Row label='Email' value={info.email} />
    <Row label='Location' value={info.location} />
    <Row label='Member since' value={smartDate(user.createdAt, { includeTime: false, includeYear: true })} />
    <Row label='Last Login' value={`${smartDate(info.lastLogin, { includeTime: false, relative: 'week' })} (${smartDate(info.lastLogin, { includeYear: true })})`} />
    <Row label='Ride Count' value={info.tripsCount} />
    <Row label='Route Count' value={info.routesCount} />
    <Row label='Subscription Level' value={info.accountLevelString} />
    <Row label='Subscription Type' value={<Fragment>{info.subscriptionTypeString} {info.subscriptionUrl && <a href={info.subscriptionUrl}>(manage)</a>}</Fragment>} />
    {info.activeTrialExpiresOn && <Row label='In active trial' value={`Ending: ${smartDate(info.activeTrialExpiresOn)}`} />}
    {info.activeTrialIsOnetime && <Row label='Current trial is onetime trial' value='true' />}
    {info.oTUCode && <Row
      label='One-time code'
      value={<Fragment>Code: {info.oTUCode} <br /> Type: ${info.oTUCodeDesc}</Fragment>} />}
    <Row label='Old Basic' value={info.oldBasic ? 'True' : 'False'} />
    <Row label='Active Experiments' value={info.activeExperiments.length > 0 ? info.activeExperiments : 'No experiments enabled'} />
    <Row label='App Version' value={<Fragment>{info.apiUserAppVersion} <a href={`/users/${user.id}/api_history`}>(manage)</a></Fragment>} />
    <Row label='Device' value={info.apiUserDevice} />
    {info.userMergedOn && <Row label='User merged' value={smartDate(info.userMergedOn)} />}
  </div>
}

export class UnauthenticateUser extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = { success: false }
  }

  onConfirm = () => {
    const { onRequestClose, userId } = this.props

    fetchJSON(`/users/${userId}/unauthenticate`, false, { method: 'POST' })
      .then(r => {
        this.setState({ success: true })
        setTimeout(() => onRequestClose(), 2000)
      })
  }

  render () {
    const { success } = this.state
    const { onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title='Log User Out Of Apps'
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={success ? onRequestClose : this.onConfirm}
        confirmText={success ? 'cool, great' : 'OK'}>
        <div>
          {success
            ? 'It done'
            : 'This will boot the user out of our Android and iOS apps. It will NOT log them out of the website'}
        </div>
      </ConfirmationDialog>
    )
  }
}

export class UserDeactivationDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      success: false,
      emptyError: false,
      error: false
    }
  }

  onSubmit = () => {
    const { userId, currentUserId } = this.props
    const body = {
      user_deactivation_audit: {
        deactivated_user_id: userId,
        deactivating_user_id: currentUserId,
        deactivated_at: moment(),
        notes: this._input.value
      }
    }

    if (this._input.value.length === 0) {
      this.setState({ emptyError: true })
      return
    }

    fetchJSON(`/users/${userId}/confirm_deactivation.json`, body, { method: 'POST' })
      .then((_) => {
        this.setState({ success: true, emptyError: false })
        window.location = '/users?recent=1'
      })
      .catch(r => {
        this.setState({ error: true })
      })
  }

  render () {
    const { success, emptyError, error } = this.state
    const { onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title='Create Deactivation Audit'
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={success ? onRequestClose : this.onSubmit}
        confirmText={success ? 'cool, great' : 'OK'}>
        <div>
          {success
            ? <div>dunzo</div>
            : <form onSubmit={this.onSubmit}>
              <label htmlFor='notes'>Circumstances/reason for deactivation?</label>
              <input
                ref={r => { this._input = r }}
                id='notes'
                type='text' />
            </form>}
          {emptyError && <p>include a note, pls</p>}
          {error && <p>whoops, something went wrong. prob show your console to a dev</p>}
          Note: user will be completely removed 2 weeks after deactivation
        </div>
      </ConfirmationDialog>
    )
  }
}

export class TrouteDeletePhotosModal extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = { success: false }
  }

  onConfirm = () => {
    const { objectType, troute } = this.props
    fetchJSON(`/${objectType}s/${troute.id}/delete_photos`, null, { method: 'POST' })
      .then(_ => {
        this.setState({ success: true })
        setTimeout(() => window.location.reload(), 1000)
      })
  }

  render () {
    const { success } = this.state
    const { onRequestClose } = this.props

    return (
      <ConfirmationDialog
        primary
        title='Delete all photos on this troute?'
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={success ? () => window.location.reload() : this.onConfirm}
        confirmText={success ? 'cool, great' : 'OK'}>
        <div>
          {success
            ? 'It done'
            : "This can't be undone, so be dang sure about it"}
        </div>
      </ConfirmationDialog>
    )
  }
}
